import React, { useState, useEffect } from 'react';
import "../../css/IdCards.css";
import { Download, Trash2, X } from 'lucide-react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../../components/Loader";

function IdCards() {
    const [activeTab, setActiveTab] = useState('student');
    const [idCards, setIdCards] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');


    const [deleteModal, setDeleteModal] = useState({
        isOpen: false,
        cardId: null,
        cardName: ''
    });

    useEffect(() => {
        fetchIdCards();
    }, [activeTab]);

    const fetchIdCards = async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            toast.error("Unauthorized! Please log in again.");
            return;
        }

        setIsLoading(true);
        try {
            const response = await fetch(`https://schoolpro-api.uniums.com/api/idcard/${activeTab}/all`, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error("Failed to fetch ID cards");
            }

            const data = await response.json();
            setIdCards(data);
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };


    const handleDeleteClick = (card) => {
        setDeleteModal({
            isOpen: true,
            cardId: card._id,
            cardName: `${card.firstName} ${card.lastName}`
        });
    };


    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };
    const filteredCards = idCards.filter(card => {
        const searchValue = searchTerm.toLowerCase();
        const fullName = `${card.firstName} ${card.lastName}`.toLowerCase();
        const idNumber = card.idNumber.toString().toLowerCase();

        return fullName.includes(searchValue) || idNumber.includes(searchValue);
    });

    const handleDownload = async (imageUrl, name) => {
        try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `IDCard_${name}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            toast.error("Failed to download ID card");
        }
    };

    const handleDelete = async () => {
        const token = localStorage.getItem("token");
        try {
            const response = await fetch(`https://schoolpro-api.uniums.com/api/idcard/${activeTab}/delete/${deleteModal.cardId}`, {
                method: 'DELETE',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error("Failed to delete ID card");
            }

            toast.success("ID card deleted successfully");
            fetchIdCards();
            setDeleteModal({ isOpen: false, cardId: null, cardName: '' });
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        }
    };
    const closeModal = () => {
        setDeleteModal({ isOpen: false, cardId: null, cardName: '' });
    };
    return (
        <div className="idcardview-container">
            <ToastContainer />

            <div className="idcardview-header">
                <h2>ID Cards</h2>
                <div className="idcardview-tabs">
                    <button
                        className={`idcardview-tab ${activeTab === 'student' ? 'active' : ''}`}
                        onClick={() => setActiveTab('student')}
                    >
                        Students
                    </button>
                    <button
                        className={`idcardview-tab ${activeTab === 'teacher' ? 'active' : ''}`}
                        onClick={() => setActiveTab('teacher')}
                    >
                        Teachers
                    </button>
                </div>
            </div>
            <div className="idcardview-search">
                <input
                    type="text"
                    placeholder={`Search ${activeTab}s by name or ${activeTab === 'student' ? 'roll number' : 'employee ID'}...`}
                    value={searchTerm}
                    onChange={handleSearch}
                    className="idcardview-search-input"
                />
            </div>

            {isLoading ? (
                <Loader />
            ) : (
                <div className="idcardview-grid">
                    {filteredCards.map((card) => (
                        <div key={card._id} className="idcardview-card">
                            <img
                                src={card.idCardImageUrl}
                                alt={`ID Card - ${card.firstName} ${card.lastName}`}
                                className="idcardview-image"
                            />
                            <div className="idcardview-actions">
                                <button
                                    className="idcardview-action-btn download"
                                    onClick={() => handleDownload(card.idCardImageUrl, `${card.firstName}_${card.lastName}`)}
                                >
                                    <Download size={18} />
                                </button>
                                <button
                                    className="idcardview-action-btn delete"
                                    onClick={() => handleDeleteClick(card)}
                                >
                                    <Trash2 size={18} />
                                </button>
                            </div>
                        </div>
                    ))}
                    {filteredCards.length === 0 && (
                        <div className="idcardview-empty">
                            {searchTerm
                                ? `No ${activeTab}s found matching "${searchTerm}"`
                                : `No ID cards found for ${activeTab}s`
                            }
                        </div>
                    )}
                </div>
            )}
            {deleteModal.isOpen && (
                <div className="idcardview-modal-overlay">
                    <div className="idcardview-modal">
                        <div className="idcardview-modal-header">
                            <h3>Delete ID Card</h3>
                            <button className="idcardview-modal-close" onClick={closeModal}>
                                <X size={20} />
                            </button>
                        </div>
                        <div className="idcardview-modal-content">
                            <p>Are you sure you want to delete the ID card for <strong>{deleteModal.cardName}</strong>?</p>
                            <p className="idcardview-modal-warning">This action cannot be undone.</p>
                        </div>
                        <div className="idcardview-modal-actions">
                            <button className="idcardview-modal-btn cancel" onClick={closeModal}>
                                Cancel
                            </button>
                            <button className="idcardview-modal-btn delete" onClick={handleDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default IdCards;